import React, { useContext } from 'react'
import { TemplatePage } from '../../../../../components/TemplatePage'
import { ScrollView, StyleSheet, Text, View } from 'react-native'
import { globalStyle } from '../../../../../theme/global'
import { corporateColor } from '../../../../../theme/colors'
import { Separator } from '../../../../../components/Separator'
import { DropdownComponent } from '../../../../../components/DropdownComponent'
import { Button } from '../../../../../components/Button'
import { useNavigation } from '@react-navigation/native'
import { LogisticsRoutes } from '../../../../../navigator/types'
import { StackNavigationProp } from '@react-navigation/stack'
import { GrayHeader } from '../../components/GrayHeader'
import { useForm } from '../../../../../hooks/useForm'
import { FuelContext } from '../../../../../context/Logistics/fuel/FuelProvider'
import moment from 'moment'
import { OrderData, Option } from '../../../../../context/Logistics/fuel/types'
import { useTranslation } from 'react-i18next'

export const ManualOrder = () => {
  const { handleOrderByType, handleSaveRecord, params } = useContext(FuelContext)
  const { t } = useTranslation()
  const navigation = useNavigation<StackNavigationProp<LogisticsRoutes, 'ManualOrder'>>()
  const { values, onChangeValues } = useForm<
    Omit<OrderData, 'orderNumber' | 'orderId' | 'orderStateId'>
  >({
    centerId: 0,
    centerName: '',
    deliveryDate: moment().format('DD/MM/YYYY'),
    pontoonId: 0,
    pontoonName: '',
    shipId: 0,
    shipName: '',
    supplierId: 0,
    supplierName: '',
  })

  const handleNext = () => {
    const now = moment()
    const statusTime = now.format('YYYY-MM-DDTHH:mm:ss')
    const orderNumber = `M${values.centerId}${now.format('YYYYMMDDHHmm')}`

    handleOrderByType(
      {
        ...values,
        orderId: 0,
        orderStateId: 0,
        statusTime,
        orderNumber,
      },
      'manual',
    )

    handleSaveRecord({
      orderId: 0,
      orderNumber,
      deliveryDate: values.deliveryDate,
      centerId: values.centerId,
      centerName: values.centerName,
      supplierId: values.supplierId,
      supplierName: values.supplierName,
      shipId: values.shipId,
      shipName: values.shipName,
      statusDetail: { Creado: { status: 'Creado', time: statusTime } },
      pontoonId: values.pontoonId,
      pontoonName: values.pontoonName,
      numberOfLiters: null,
      testResult: null,
      meterNumber: null,
      voucherNumber: null,
      photos: null,
      stateForm: 'in-progress',
      savedAt: null,
    })

    navigation.navigate('InitialPhotoRod')
  }

  return (
    <TemplatePage
      styleContent={{ padding: 0, marginBottom: 0 }}
      title={t('Recepción combustible')}
      header
    >
      <ScrollView style={[globalStyle.viewContainer, { padding: 0 }]}>
        <GrayHeader title={t('Ingreso pedido manual')} />
        <View style={{ padding: 24, paddingBottom: 120 }}>
          <View style={{ marginBottom: 16 }}>
            <Text style={style.label}>{t('Fecha de entrega')}</Text>
            <Text style={style.subLabel}>{values.deliveryDate}</Text>
          </View>

          <Separator customStyle={{ borderBottomWidth: 1, marginBottom: 16 }} />

          <DropdownComponent
            label={t('Centro')}
            data={params.centers}
            onChange={(_, item) => {
              onChangeValues({ name: 'centerId', value: item!.id })
              onChangeValues({ name: 'centerName', value: item!.name })
            }}
            placeholder={t('Seleccione')}
            hasIcon
            containerStyles={{ marginBottom: 16 }}
            hasSearch
          />

          <DropdownComponent
            label={t('Proveedor')}
            data={params.suppliers}
            onChange={(_, item) => {
              onChangeValues({ name: 'supplierId', value: item!.id })
              onChangeValues({ name: 'supplierName', value: item!.name })
            }}
            placeholder={t('Seleccione')}
            hasIcon
            containerStyles={{ marginBottom: 16 }}
          />

          <DropdownComponent
            label={t('Embarcación')}
            data={params.ship[values.supplierId] ?? []}
            onChange={(_, item) => {
              onChangeValues({ name: 'shipId', value: item!.id })
              onChangeValues({ name: 'shipName', value: item!.name })
            }}
            placeholder={t('Seleccione')}
            hasIcon
            containerStyles={{ marginBottom: 16 }}
          />

          <DropdownComponent
            label='Pontón/Oxzo'
            data={(params.navalArtifact[values.centerId] ?? []) as Option[]}
            onChange={(_, item) => {
              onChangeValues({ name: 'pontoonId', value: item!.id })
              onChangeValues({ name: 'pontoonName', value: item!.name })
            }}
            placeholder={t('Seleccione')}
            hasIcon
            containerStyles={{ marginBottom: 16 }}
          />
        </View>
      </ScrollView>

      <View style={style.containerBtn}>
        <Button
          label={t('Volver')}
          onPress={() => navigation.goBack()}
          customStyle={[{ width: 200, padding: 8, paddingVertical: 12 }]}
          variant='white'
        />
        <Button
          label={t('Iniciar prueba de agua')}
          onPress={handleNext}
          customStyle={{ width: 200, padding: 8, paddingVertical: 12 }}
          disabled={Object.values(values).some((val) => val === 0 || val === '')}
        />
      </View>
    </TemplatePage>
  )
}

const style = StyleSheet.create({
  label: {
    fontWeight: '500',
    fontSize: 18,
    color: corporateColor,
  },
  subLabel: { fontWeight: '400', fontSize: 16, color: corporateColor },
  containerBtn: {
    alignItems: 'center',
    position: 'absolute',
    bottom: 20,
    width: '100%',
    gap: 8,
  },
})
